import { Platform } from './Platform';
import { SupportedCompaniesTypes, SupportedCompanyPlatforms } from './types';

export type MapPlatforms<T> = Partial<
    {
        [C in SupportedCompaniesTypes | 'default']: Partial<
            {
                [P in SupportedCompanyPlatforms | 'default']: T;
            }
        >;
    }
>;

type MapGetter<T> = (platform: string | Platform) => T;

export function mapByPlatform<T = any>(platforms: MapPlatforms<T>): MapGetter<T>;
export function mapByPlatform<T = any>(platforms: MapPlatforms<T>, platform: string | Platform): T;

export function mapByPlatform<T = any>(platforms: MapPlatforms<T>, platform?: string | Platform) {
    function getter(platform: string | Platform): T | null {
        const platform$ = Platform.from(platform);
        const selectedCompany = platforms[platform$.getCompany()] || platforms.default || null;

        if (selectedCompany) {
            return selectedCompany[platform$.getPlatform()] || selectedCompany.default || null;
        }

        return null;
    }

    return platform ? getter(platform) : getter;
}
